import React from 'react';
import { DoubleChevronLeft, DoubleChevronRight, DoubleChevronDown } from '../ImageViewerIcons';
import { ONBOARDING_DURATION, ONBOARDING_SWIPE_ANIMATION_DURATION } from '../imageViewerUtils';

// CSS animations for onboarding overlay
const onboardingStyles = `
    @keyframes onboardingFade {
        0% { opacity: 0; }
        15% { opacity: 1; }
        50% { opacity: 1; }
        100% { opacity: 0; }
    }
    @keyframes swipeLeft {
        0% { transform: translateX(1em); }
        99% { transform: translateX(-0.5em); }
        100% { transform: translateX(1em); }
    }
    @keyframes swipeRight {
        0% { transform: translateX(-1em); }
        99% { transform: translateX(0.5em); }
        100% { transform: translateX(-1em); }
    }
    @keyframes swipeDown {
        0% { transform: translateY(-1em); }
        99% { transform: translateY(0.5em); }
        100% { transform: translateY(-1em); }
    }
`;

/**
 * Mobile onboarding overlay showing swipe hints
 * Displays animated arrows on first visit to teach swipe gestures
 */
const OnboardingOverlay = () => {
    const fadeAnimation = { 
        animation: `onboardingFade ${ONBOARDING_DURATION}ms ease-out forwards` 
    };
    
    return (
        <div 
            className="absolute inset-0 pointer-events-none"
            style={{ zIndex: 10000 }}
        >
            <style dangerouslySetInnerHTML={{ __html: onboardingStyles }} />
            
            {/* Left double chevron - swipe for previous */}
            <div 
                className="absolute left-0 top-1/2 -translate-y-1/2 p-2"
                style={fadeAnimation}
            >
                <DoubleChevronLeft 
                    style={{ 
                        color: 'var(--color-text)', 
                        animation: `swipeLeft ${ONBOARDING_SWIPE_ANIMATION_DURATION}ms linear infinite` 
                    }}
                />
            </div>
            
            {/* Right double chevron - swipe for next */}
            <div 
                className="absolute right-0 top-1/2 -translate-y-1/2 p-2"
                style={fadeAnimation}
            >
                <DoubleChevronRight 
                    style={{ 
                        color: 'var(--color-text)', 
                        animation: `swipeRight ${ONBOARDING_SWIPE_ANIMATION_DURATION}ms linear infinite` 
                    }}
                />
            </div>
            
            {/* Down double chevron - swipe to close */}
            <div 
                className="absolute bottom-0 left-1/2 -translate-x-1/2 p-2"
                style={fadeAnimation}
            >
                <DoubleChevronDown 
                    style={{ 
                        color: 'var(--color-text)', 
                        animation: `swipeDown ${ONBOARDING_SWIPE_ANIMATION_DURATION}ms linear infinite` 
                    }}
                />
            </div>
        </div>
    );
};

export default OnboardingOverlay;
